import cn from 'classnames';
import React from 'react';
import {
  SelfOnboardingStepKey,
  SelfOnboardingStepProps,
} from 'containers/selfOnboarding/steps/types';

export type ReviewProfilePhotoContainer = React.PropsWithChildren<
  Pick<SelfOnboardingStepProps, 'navigation'> & { className?: string }
>;

export function ReviewProfilePhotoContainer(
  props: ReviewProfilePhotoContainer,
): React.ReactElement {
  const { children, navigation, className = '' } = props;
  const { goToStep } = navigation;

  return (
    <div
      className={cn('odin-flex', className)}
      onClickCapture={(
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
      ): void => {
        e.stopPropagation();
        goToStep(SelfOnboardingStepKey.ProfilePhoto);
      }}
    >
      {children}
    </div>
  );
}
